module.exports = __webpack_public_path__ + "static/media/1-4.b06b3c20.mp3";